<template>
    <el-dialog title="Detail" :visible.sync="dialogVisible" width="900px" :before-close="handleClose">
        <el-form ref="form" :model="form" label-width="130px" label-position="left">
            <el-form-item label="en-title:">
                <el-input v-model="form.en.title"></el-input>
            </el-form-item>
            <el-form-item label="en-prompt:">
                <el-input type="textarea" v-model="form.en.prompt"></el-input>
            </el-form-item>
            <el-form-item label="en-description:">
                <el-input type="textarea" v-model="form.en.description"></el-input>
            </el-form-item>

            <el-form-item label="zh-title:">
                <el-input v-model="form.zh.title"></el-input>
            </el-form-item>
            <el-form-item label="zh-prompt:">
                <el-input type="textarea" v-model="form.zh.prompt"></el-input>
            </el-form-item>
            <el-form-item label="zh-description:">
                <el-input type="textarea" v-model="form.zh.description"></el-input>
            </el-form-item>

            <el-form-item label="origin-title:">
                <el-input v-model="form.origin.title"></el-input>
            </el-form-item>
            <el-form-item label="origin-prompt:">
                <el-input type="textarea" v-model="form.origin.prompt"></el-input>
            </el-form-item>
            <el-form-item label="origin-description:">
                <el-input type="textarea" v-model="form.origin.description"></el-input>
            </el-form-item>

            <el-form-item label="topics:">
                <el-select v-model="form.topics" multiple placeholder="请选择" style="width: 100%" disabled>
                    <el-option v-for="item in optionList" :key="item" :label="item" :value="item"></el-option>
                </el-select>
            </el-form-item>

            <!-- <el-row>
                <el-col :span="11">
                    <el-form-item label-width="84px" label="creat_at">
                        <el-input v-model="created_at" disabled></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="2">&nbsp;</el-col>
                <el-col :span="11">
                    <el-form-item label-width="84px" label="last_edit_at">
                        <el-input v-model="last_edit_at" disabled></el-input>
                    </el-form-item>
                </el-col>
            </el-row> -->

            <el-row>
                <el-col :span="7">
                    <el-form-item label-width="84px" label="creat_at">
                        <el-input v-model="created_at" disabled></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="1">&nbsp;</el-col>
                <el-col :span="7">
                    <el-form-item label-width="84px" label="last_edit_at">
                        <el-input v-model="last_edit_at" disabled></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="1">&nbsp;</el-col>
                <el-col :span="8">
                    <el-form-item label-width="120px" label="Score">
                        <el-input v-model="form.score" disabled></el-input>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="7">
                    <el-form-item label-width="84px" label="total view">
                        <el-input v-model="form.total_view" disabled></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="1">&nbsp;</el-col>
                <el-col :span="7">
                    <el-form-item label-width="84px" label="real view">
                        <el-input v-model="form.view" disabled></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="1">&nbsp;</el-col>
                <el-col :span="8">
                    <el-form-item label-width="120px" label="promotion view">
                        <el-input v-model="form.promotion_view"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="7">
                    <el-form-item label-width="84px" label="total copied">
                        <el-input v-model="form.total_copy" disabled></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="1">&nbsp;</el-col>
                <el-col :span="7">
                    <el-form-item label-width="84px" label="real copied">
                        <el-input v-model="form.copy" disabled></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="1">&nbsp;</el-col>
                <el-col :span="8">
                    <el-form-item label-width="120px" label="promotion copied">
                        <el-input v-model="form.promotion_copy"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="7">
                    <el-form-item label-width="84px" label="total liked">
                        <el-input v-model="form.total_focus" disabled></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="1">&nbsp;</el-col>
                <el-col :span="7">
                    <el-form-item label-width="84px" label="real liked">
                        <el-input v-model="form.focus" disabled></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="1">&nbsp;</el-col>
                <el-col :span="8">
                    <el-form-item label-width="120px" label="promotion liked">
                        <el-input v-model="form.promotion_focus"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="7">
                    <el-form-item label-width="84px" label="total saved">
                        <el-input v-model="form.total_collect" disabled></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="1">&nbsp;</el-col>
                <el-col :span="7">
                    <el-form-item label-width="84px" label="real saved">
                        <el-input v-model="form.collect" disabled></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="1">&nbsp;</el-col>
                <el-col :span="8">
                    <el-form-item label-width="120px" label="promotion saved">
                        <el-input v-model="form.promotion_collect"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>

            <!-- <el-form-item label="views:">
                <el-input v-model="form.view"></el-input>
            </el-form-item>

            <el-form-item label="copied:">
                <el-input v-model="form.copy"></el-input>
            </el-form-item>

            <el-form-item label="liked:">
                <el-input v-model="form.focus"></el-input>
            </el-form-item>

            <el-form-item label="saved:">
                <el-input v-model="form.collect"></el-input>
            </el-form-item> -->

            <!-- <el-form-item></el-form-item> -->
        </el-form>

        <span slot="footer" class="dialog-footer">
            <el-button @click="handleClose">Cancel</el-button>
            <el-button type="primary" :loading="loading" @click="onSubmit">Submit</el-button>
        </span>
    </el-dialog>
</template>

<script>
import serverApi from '../../../server/index';
export default {
    props: ['dialogVisible', 'initData'],
    data() {
        return {
            form: {
                en: {
                    title: '',
                    prompt: '',
                    description: '',
                },
                zh: {
                    title: '',
                    prompt: '',
                    description: '',
                },
                origin: {
                    title: '',
                    prompt: '',
                    description: '',
                },
                topics: [],
                score: 0,
                total_view: 0,
                view: 0,
                promotion_view: 0,

                total_copy: 0,
                copy: 0,
                promotion_copy: 0,

                total_focus: 0,
                focus: 0,
                promotion_focus: 0,

                total_collect: 0,
                collect: 0,
                promotion_collect: 0,
            },
            created_at: '',
            last_edit_at: '',
            optionList: [],
            loading: false,
        };
    },
    
    mounted() {
        if (this.initData) {
            this.form = this.initData;
            this.optionList = this.initData.topics;
            this.created_at = this.$moment(new Date(this.initData.created_at).getTime()).utc().format('YYYY-MM-DD HH:mm:ss');
            this.last_edit_at = this.$moment(new Date(this.initData.last_edit_at).getTime()).utc().format('YYYY-MM-DD HH:mm:ss');
        }
    },
    methods: {
        onSubmit() {
            this.loading = true;
            const params = {
                en: this.form.en,
                zh: this.form.zh,
                origin: this.form.origin,
                // view: Number(this.form.view || 0),
                // copy: Number(this.form.copy || 0),
                // focus: Number(this.form.focus || 0),
                // collect: Number(this.form.collect || 0),
                promotion_view: Number(this.form.promotion_view || 0),
                promotion_copy: Number(this.form.promotion_copy || 0),
                promotion_focus: Number(this.form.promotion_focus || 0),
                promotion_collect: Number(this.form.promotion_collect || 0),
                id: this.initData._id,
            };
            serverApi
                .promptSave(params)
                .then(res => {
                    if (res.data.code === 0) {
                        this.$message({
                            message: 'Edit successfully',
                            type: 'success',
                        });
                        this.$emit('closeDetail', true);
                    } else {
                        this.$message({
                            message: res.data.msg || res.data.error,
                            type: 'error',
                        });
                    }
                })
                .catch(e => {
                    this.$message({
                        message: e.data.error || e.data.msg,
                        type: 'error',
                    });
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        handleClose() {
            this.$emit('closeDetail', false);
        },
    },
};
</script>

<style lang="scss" scoped></style>
